import { PERMITTED_VIEWS } from '../global/global.constant';
import {
  QuickAccessActionMeta,
  QuickAccessNavMode,
} from '../../interfaces/ui/quick-access.interface';

export const QUICK_ACCESS_STORAGE_KEY_PREFIX = 'quickAccessMenu_';
export const QUICK_ACCESS_HINT_SEEN_KEY_PREFIX = 'quickAccessHintSeen_';
export const QUICK_ACCESS_LABELS_KEY_PREFIX = 'quickAccessLabels_';
export const QUICK_ACCESS_ICONS_KEY_PREFIX = 'quickAccessIcons_';
export const QUICK_ACCESS_NAV_MODE_KEY_PREFIX = 'quickAccessNavMode_';
export const QUICK_ACCESS_FLOATING_POSITION_KEY_PREFIX = 'quickAccessFloatingY_';
export const QUICK_ACCESS_FLOATING_SIDE_KEY_PREFIX = 'quickAccessFloatingSide_';

export const MAX_QUICK_ACCESS_ITEMS = 5;
export const QUICK_ACCESS_MIDDLE_SLOT_INDEX = 2;
export const QUICK_ACCESS_TRAY_LIST_ID = 'selectedTray';
export const QUICK_ACCESS_DRAG_START_DELAY = { touch: 100, mouse: 0 };

export const QUICK_ACCESS_SHEET_WINDOW_CLASS = 'quick-access-sheet';
export const QUICK_ACCESS_SHEET_DIALOG_CLASS = 'quick-access-sheet-dialog';

export const QUICK_ACCESS_MENU_TYPE_LINK = 'link';
export const QUICK_ACCESS_MENU_TYPE_SUB = 'sub';

export const QUICK_ACCESS_NAV_MODE_BOTTOM_BAR: QuickAccessNavMode = 'bottom-bar';
export const QUICK_ACCESS_NAV_MODE_FLOATING_BUTTON: QuickAccessNavMode = 'floating-button';
export const QUICK_ACCESS_NAV_MODE_HIDDEN: QuickAccessNavMode = 'hidden';
export const QUICK_ACCESS_MOBILE_BREAKPOINT_PX = 992;

export const QUICK_ACCESS_FLOATING_DEFAULT_OFFSET_Y = -120;
export const QUICK_ACCESS_FLOATING_TOP_MARGIN = 72;
export const QUICK_ACCESS_FLOATING_BOTTOM_MARGIN = 16;
export const QUICK_ACCESS_LIMIT_NOTICE_MS = 2600;
export const QUICK_ACCESS_COMPACT_BAR_MAX_ITEMS = 3;


export const QUICK_ACCESS_DEFAULT_PRIORITY_IDS: string[] = [
  PERMITTED_VIEWS.DASHBOARD,
  PERMITTED_VIEWS.PLAYERS,
  PERMITTED_VIEWS.PAGE_MANAGEMENT_SECTION,
  PERMITTED_VIEWS.PAGE_MANAGEMENT_PROMOTION,
  PERMITTED_VIEWS.REPORTS_SPORTS_BETTING_BETTING,
  PERMITTED_VIEWS.REPORTS_CASINO_BY_BETS,
];

export const FA_ICON_PREFIX = 'fa:';

export const QUICK_ACCESS_ACTION_FALLBACK_ICON = `${FA_ICON_PREFIX}money`;

export const QUICK_ACCESS_ACTIONS: QuickAccessActionMeta[] = [
  {
    id: PERMITTED_VIEWS.BTN_TRANSFER_PLAYER,
    titleKey: 'mobileNav.loadsAndWithdrawal',
    icon: `${FA_ICON_PREFIX}money`,
  },
  {
    id: PERMITTED_VIEWS.BTN_ADD_PLAYER,
    titleKey: 'mobileNav.addPlayer',
    icon: `${FA_ICON_PREFIX}user-plus`,
  },
];

export const QUICK_ACCESS_ICON_CHOICES: string[] = [
  'home',
  'user',
  'contact',
  'ecommerce',
  'charts',
  'table',
  'form',
  'file',
  'board',
  'project',
  'layout',
  'widget',
  'task',
  'to-do',
  'calender',
  'email',
  'chat',
  'social',
  'bookmark',
  'search',
  'gallery',
  'blog',
  'maps',
  'learning',
  'job-search',
  'editors',
  'knowledgebase',
  'support-tickets',
  'faq',
  'others',
];

const FA_ICON_NAMES: string[] = [
  'money',
  'credit-card',
  'credit-card-alt',
  'dollar',
  'eur',
  'bank',
  'university',
  'calculator',
  'percent',
  'balance-scale',
  'exchange',
  'shopping-cart',
  'shopping-bag',
  'line-chart',
  'bar-chart',
  'pie-chart',
  'area-chart',
  'tachometer',
  'dashboard',
  'table',
  'th',
  'th-large',
  'columns',
  'list',
  'list-ul',
  'list-ol',
  'sitemap',
  'database',
  'server',
  'filter',
  'sort-amount-desc',
  'user',
  'users',
  'user-plus',
  'user-times',
  'user-circle',
  'user-circle-o',
  'user-secret',
  'address-book',
  'address-card',
  'id-card',
  'street-view',
  'futbol-o',
  'soccer-ball-o',
  'trophy',
  'gamepad',
  'diamond',
  'star',
  'star-o',
  'heart',
  'gift',
  'ticket',
  'bullseye',
  'crosshairs',
  'clock-o',
  'calendar',
  'calendar-check-o',
  'history',
  'hourglass-half',
  'file-text-o',
  'file-excel-o',
  'file-pdf-o',
  'files-o',
  'folder-open',
  'folder-open-o',
  'download',
  'upload',
  'cloud-download',
  'cloud-upload',
  'print',
  'paperclip',
  'envelope',
  'envelope-o',
  'comments',
  'comments-o',
  'commenting-o',
  'bell',
  'bell-o',
  'bullhorn',
  'paper-plane',
  'share-alt',
  'phone',
  'whatsapp',
  'telegram',
  'shield',
  'lock',
  'unlock-alt',
  'key',
  'cog',
  'cogs',
  'wrench',
  'sliders',
  'sign-in',
  'sign-out',
  'power-off',
  'ban',
  'check-circle',
  'times-circle',
  'exclamation-triangle',
  'info-circle',
  'question-circle',
  'eye',
  'eye-slash',
  'home',
  'globe',
  'flag',
  'map-marker',
  'search',
  'tag',
  'tags',
  'bookmark',
  'link',
  'external-link',
  'refresh',
  'random',
  'bolt',
  'fire',
  'rocket',
  'life-ring',
  'thumbs-up',
  'briefcase',
  'building',
  'truck',
  'barcode',
  'qrcode',
  'mobile',
  'desktop',
  'laptop',
  'tv',
  'camera',
  'picture-o',
  'video-camera',
  'book',
  'graduation-cap',
  'pencil',
  'trash',
  'plus-circle',
  'minus-circle',
];

export const QUICK_ACCESS_FA_ICON_CHOICES: string[] = FA_ICON_NAMES.map(
  (name) => `${FA_ICON_PREFIX}${name}`
);
